import { jsx as _jsx } from "react/jsx-runtime";
import { getEstadosCivis } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function EstadosCivis() {
    return _jsx(GridBase, { pagina: PAGINAS.ESTADOS_CIVIS, paginaPermissao: FUNCIONALIDADES.ESTADOS_CIVIS, rota: ROUTES.ESTADOS_CIVIS, fetchData: function (str, _, pag) { return getEstadosCivis(str, pag); }, columns: COLUNAS });
}
